import { useMemo } from 'react';
import Typography from 'components/gruenland/atoms/typography';
import { sortCategoryGroups } from 'helpers/categoryHelpers/categoryGroupSort';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import MobileMenuNavButton from '../atoms/MobileMenuNavButton';

export interface Props {
  categories: Category[];
  hideHeaderMenu: () => void;
  insertCategory: (category: Category) => void;
}

const MobileMenuContentLevel2: React.FC<Props> = ({ categories, hideHeaderMenu, insertCategory }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const groups = useMemo(() => {
    return sortCategoryGroups(categories);
  }, [categories]);

  return (
    <>
      {groups.map((x, i) => (
        <div key={i} className="mb-5">
          <Typography className="font-bold">
            {formatMessage({ id: `categoryGroup.${x}`, defaultMessage: x })}
          </Typography>
          <div>
            {categories
              .filter((c) => c.customGroup === x)
              .map((nav) => (
                <MobileMenuNavButton
                  key={nav.categoryId}
                  link={nav}
                  onClick={() => insertCategory(nav)}
                  hideHeaderMenu={hideHeaderMenu}
                />
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default MobileMenuContentLevel2;
